import React, { useEffect, useState } from 'react';

// Yerel veri
const initData = {
    heading: "Sıkça Sorulan Sorular",
   // headingText: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati dignissimos quae quo ad iste ipsum officiis deleniti asperiores sit.",
    headingTexttwo: " ",
   // faqText: "Haven't find suitable answer?",
   // faqTextLink: "Tell us what you need."
};

// Yerel SSS verileri
const faqData = [
    {
        id: 1,
        title: "Socia nedir ve ne işe yarar?",
        content: "Socia, şehrinizdeki niş etkinlikleri (canlı müzik, workshop, söyleşi vb.) keşfetmenize yardımcı olan bir platformdur."
    },
    {
        id: 2,
        title: "Socia’yı nasıl kullanabilirim?",
        content: "Uygulamayı indirerek ilgi alanlarınıza uygun etkinlikleri keşfedebilir, favori organizatörleri takip edebilirsiniz."
    },
    {
        id: 3,
        title: "Socia hangi şehirlerde aktif?",
        content: "Şu an Ankara’da aktifiz. Yakında diğer şehirlerde de kullanıma açılacağız."
    },
    {
        id: 4,
        title: "Socia’daki etkinlikler nasıl seçiliyor?",
        content: "Instagram’da duyurulan ve bilet platformlarında yer almayan niş etkinlikleri manuel olarak ekliyoruz."
    }
];

// Yerel SSS verileri iki
const faqDataTwo = [
    {
        id: 1,
        title: "Etkinlikleri nasıl filtreleyebilirim?",
        content: "Tarih, kategori (konser, tiyatro, atölye vb.) veya konum gibi kriterlere göre filtreleme yapabilirsiniz."
    },
    {
        id: 2,
        title: "Socia üzerinden etkinlik bileti alabilir miyim?",
        content: "Şu an için bilet satışı yapmıyoruz, ancak organizatörlerin ödeme yada rezervasyon platformlarına yönlendirme sağlıyoruz."
    },
    {
        id: 3,
        title: "Ben de etkinlik ekleyebilir miyim?",
        content: "Evet! Eğer etkinlik düzenleyen bir organizatörseniz, bizimle iletişime geçerek organizatör olarak uygulamaya dahil olabilirsiniz."
    },
    {
        id: 4,
        title: "Socia’da yer almak için ücret ödemem gerekiyor mu?",
        content: "Hayır, şu an etkinlik eklemek tamamen ücretsizdir."
    }
];

const FaqSection = () => {
    const [data, setData] = useState({});
    const [faqs, setFaqs] = useState([]);
    const [faqsTwo, setFaqsTwo] = useState([]);

    useEffect(() => {
        // API yerine yerel sabitlerden veri ayarlama
        setData(initData);
        setFaqs(faqData);
        setFaqsTwo(faqDataTwo);
    }, []);

    return (
        <section className="section faq-area style-two ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize">{data.heading}</h2>
                            <p className="d-none d-sm-block mt-4">{data.headingText}</p>
                            <p className="d-block d-sm-none mt-4">{data.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12">
                        {/* FAQ Content */}
                        <div className="faq-content">
                            {/* sApp Accordion */}
                            <div className="accordion" id="sApp-accordion">
                                <div className="row justify-content-center">
                                    <div className="col-12 col-md-6">
                                        {/* Single Card */}
                                        {faqs.map((item, idx) => (
                                            <div key={`fo_${idx}`} className="card border-0">
                                                {/* Card Header */}
                                                <div className="card-header bg-inherit border-0 p-0">
                                                    <h2 className="mb-0">
                                                        <button className="btn px-0 py-2" type="button">
                                                            {item.title}
                                                        </button>
                                                    </h2>
                                                </div>
                                                {/* Card Body */}
                                                <div className="card-body px-0 py-3">
                                                    {item.content}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="col-12 col-md-6">
                                        {/* Single Card */}
                                        {faqsTwo.map((item, idx) => (
                                            <div key={`ft_${idx}`} className="card border-0">
                                                {/* Card Header */}
                                                <div className="card-header bg-inherit border-0 p-0">
                                                    <h2 className="mb-0">
                                                        <button className="btn px-0 py-2" type="button">
                                                            {item.title}
                                                        </button>
                                                    </h2>
                                                </div>
                                                {/* Card Body */}
                                                <div className="card-body px-0 py-3">
                                                    {item.content}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <p className="text-body text-center pt-4 fw-5">
                                        {data.faqText} <a href="/contact-page">{data.faqTextLink}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;